/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List the runtime permission catalog.
 */
export const getPermissionsCatalog = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/permissions/catalog`, method: 'GET', signal
    },
      options);
    }




export const getGetPermissionsCatalogQueryKey = () => {
    return [
    `/permissions/catalog`
    ] as const;
    }


export const getGetPermissionsCatalogQueryOptions = <TData = Awaited<ReturnType<typeof getPermissionsCatalog>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPermissionsCatalog>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPermissionsCatalogQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPermissionsCatalog>>> = ({ signal }) => getPermissionsCatalog(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPermissionsCatalog>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPermissionsCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof getPermissionsCatalog>>>
export type GetPermissionsCatalogQueryError = unknown


/**
 * @summary List the runtime permission catalog.
 */

export function useGetPermissionsCatalog<TData = Awaited<ReturnType<typeof getPermissionsCatalog>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPermissionsCatalog>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPermissionsCatalogQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






